module.exports = __webpack_public_path__ + "static/media/uppercase.5c75340a.svg";